import { ChangeEvent, useRef } from 'react';

/**
 * Ref-based hidden file input helper: `openPicker` resets and clicks the input,
 * `handleFileSelected` forwards the chosen file to the callback.
 */
export const useFilePicker = (onFileSelected: (file: File) => void) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const openPicker = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
      fileInputRef.current.click();
    }
  };

  const handleFileSelected = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) onFileSelected(file);
  };

  return { fileInputRef, openPicker, handleFileSelected };
};

export default useFilePicker;
